//React
import React from 'react';
import { useEffect } from 'react';

//Leaflet
import { MapContainer, TileLayer, LayersControl, ZoomControl, useMapEvents } from 'react-leaflet';

//Components
import MapAction from './MapAction';
import MapLoader from './MapLoader';
import MapCadastreLayer from './MapCadastreLayer';
import MapRegionLayer from './MapRegionLayer';
import MapDepartementLayer from './MapDepartementLayer';
import MapCommuneLayer from './MapCommuneLayer';

//Bootstrap

//Hooks

//Params
interface MapParams {
    children?: any;
    decalageGauche?: number;
}


function Map({ children, decalageGauche = 0 }: MapParams) {
    useEffect(() => {
        const L = require("leaflet");

        delete L.Icon.Default.prototype._getIconUrl;

        L.Icon.Default.mergeOptions({
            iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
            iconUrl: require("leaflet/dist/images/marker-icon.png"),
            shadowUrl: require("leaflet/dist/images/marker-shadow.png")
        });
    }, []);
    
    return (
        <MapContainer center={[48.85339681291493, 2.348791338936963]} zoom={16} zoomControl={false} scrollWheelZoom={true} style={{position: 'absolute', height: "100%", width: "calc(100% - "+decalageGauche+"px)", zIndex: 1}}>
            <LayersControl position="topright">
                <LayersControl.BaseLayer checked name="Sattelite">
                    <TileLayer
                        attribution='© Google Maps'
                        url="https://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}"
                        maxZoom={20}
                        subdomains="['mt0','mt1','mt2','mt3']"
                    />
                </LayersControl.BaseLayer>
                <LayersControl.BaseLayer name="Rue">
                    <TileLayer
                        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        maxZoom={20}
                    />
                </LayersControl.BaseLayer>
            </LayersControl>
            <ZoomControl position="topright"  />
            <MapAction />
            <MapLoader />
            <MapRegionLayer />
            <MapDepartementLayer />
            <MapCommuneLayer />
            {children}
        </MapContainer>
    );
}

export default Map;